import Axios from '@/plugins/axios'

/**
 * 逐级加载地区数据
 */
export function subRegionList(id, subType) {
  const config = {
    url: `/seamark/common/data-dict/step-by-step-load/${id}?subType=${subType}`,
    method: 'GET',
  }
  return Axios(config)
}

/**
 * 查询洲列表
 */
export function continentList() {
  const config = {
    url: '/seamark/common/data-dict/continent-list',
    method: 'GET',
  }
  return Axios(config)
}

// 地区搜索
export function searchregion(keyword) {
  const config = {
    url: '/seamark/common/data-dict/area/keyword-region-search/' + keyword,
    method: 'GET',
  }
  return Axios(config)
}

// 潜在客户列表
export function getProspectList(params) {
  const config = {
    url: '/seamark/supplier-customer/prospect-list',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 成交客户列表
export function getSoldList(params) {
  const config = {
    url: '/seamark/supplier-customer/sold-list',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 联系人列表
export function getUserList(params) {
  const config = {
    url: '/seamark/supplier-customer/user-list',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 标签列表
export function getTagList(params) {
  const config = {
    url: '/seamark/tag/list',
    method: 'POST',
    data: {},
  }
  return Axios(config)
}

// 关注客户
export function setCustomerFocus(params) {
  const config = {
    url: '/seamark/supplier-customer/focus',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 客户跟进
export function setCustomerFollow(params) {
  const config = {
    url: '/seamark/supplier-customer/follow',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 客户跟进记录
export function getCustomerFollowList(params) {
  const config = {
    url: '/seamark/supplier-customer/follow-list',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 联系人列表
export function getContactList(params) {
  const config = {
    url: '/seamark/supplier-customer/contact-list',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 联系人详情
export function getContactDetail(params) {
  const config = {
    url: '/seamark/supplier-customer/customer-detail',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 查询客户名称
export function getSearchCustomerName(params) {
  const config = {
    url: '/seamark/supplier-customer/search-customer-name',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 联系人详情日志
export function getlistCustomerUserLog(params) {
  const config = {
    url: '/seamark/supplier-customer/list-customer-user-log',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 导入联系人
export function importContact(params) {
  const config = {
    url: '/seamark/supplier-customer/import-contact',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  return Axios(config)
}

// 导入联系人
export function getImportContactTask(params) {
  const config = {
    url: '/seamark/supplier-customer/get-import-contact-task',
    method: 'GET',
  }
  return Axios(config)
}

// 导入联系人
export function clearImportContact(params) {
  const config = {
    url: '/seamark/supplier-customer/clear-import-contact-task',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 单个联系人邮件发送记录
export function singleContactEmailSendRecord(params) {
  const config = {
    url: '/seamark/supplier-customer/single-contact/email-send-record',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 校验联系人是否可以发送邮件
export function userSendEmailVerify(params) {
  const config = {
    url: `/seamark/supplier-customer/customer-user/send-email-verify`,
    method: 'POST',
    data:params,
    noMessage:true
  }
  return Axios(config);
}